import { render, staticRenderFns } from "./PedidoDeCompraSolicitacarRevisaoView.vue?vue&type=template&id=35763156&scoped=true"
import script from "./PedidoDeCompraSolicitacarRevisaoView.vue?vue&type=script&setup=true&lang=js"
export * from "./PedidoDeCompraSolicitacarRevisaoView.vue?vue&type=script&setup=true&lang=js"
import style0 from "./PedidoDeCompraSolicitacarRevisaoView.vue?vue&type=style&index=0&id=35763156&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35763156",
  null
  
)

export default component.exports